module.exports = __webpack_public_path__ + "assets/img/Jd.18f74bff.png";